import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapLocationDot } from '@fortawesome/free-solid-svg-icons';

import './place.css';

const Place = () => {
  return (
    <div className="giswnauce__place">
        <div className="giswnauce__place-container">
            <span className="anchor-place" id="giswnauce_place"></span>
            <div className="place-container_header">
                <p><FontAwesomeIcon icon={faMapLocationDot} /></p><h1>Miejsce</h1>
            </div>
            <div className="place-container_subheader">
                <h2>Miejsce konferencji zostanie opublikowany wkrótce.</h2>
            </div>
        </div> 
    </div>
  )
}

export default Place